import * as React from 'react';

export const UnlockedLockIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.4977 5.62093H11.8311C11.8311 3.77998 10.3387 2.2876 8.49772 2.2876C6.65677 2.2876 5.16439 3.77998 5.16439 5.62093V7.62093H3.83496V15.6209H13.1683V7.62093H6.49772V5.62093C6.49772 4.51636 7.39315 3.62093 8.49772 3.62093C9.60229 3.62093 10.4977 4.51636 10.4977 5.62093ZM7.1696 10.9543C7.1696 10.2179 7.76655 9.62093 8.50293 9.62093C9.23931 9.62093 9.83626 10.2179 9.83626 10.9543C9.83626 11.4478 9.56813 11.8787 9.1696 12.1092V13.6209H7.83626V12.1092C7.43773 11.8787 7.1696 11.4478 7.1696 10.9543Z"
            fill="url(#paint0_linear_2941_7055)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_2941_7055"
                x1="10.8166"
                y1="1.04168"
                x2="2.85947"
                y2="15.0677"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#394AFF" stopOpacity="0.901961" />
                <stop offset="1" stopColor="#7C87FF" stopOpacity="0.666667" />
            </linearGradient>
        </defs>
    </svg>
);
